import { Richtext } from "@lib/richtext/richtext.es";
import { IAppState } from "@root/types";
import { View } from "dhx-optimus";

export default class RichTextView extends View<IAppState> {
	richtext: Richtext;

	initialContent: string;

	toolbarConfig: string[];

	init() {
		this.initialContent =
			"<p style='text-align: right;'>Date: October 11, 2021</p><p style='text-align: left;'></p><h1 style='text-align: center;'><b>MEDICAL CERTIFICATE</b></h1><p style='text-align: left;'></p><p>This is to certify that Mr./Mrs./Ms. <b>[Patient Name]</b>, also known as <b>[Title]</b> at <b>[Company Name]</b>, has undergone medical treatment conducted at <b>[Hospital Address]</b> from <b>[Start Date]</b> to <b>[End Date]</b>.</p><p>The attending physician, Dr. <b>[Doctor Name]</b>, has advised that the individual should be allowed absence from their company duties for a period of <b>[Number of Days]</b> days starting from the day of leaving the hospital.</p><p></p><p style='text-align: right;'><b>[Name]</b></p><p style='text-align: right;'><b>[Title]</b></p>";

		this.toolbarConfig = [
			"undo",
			"redo",
			"separator",
			"style",
			"separator",
			"font-family",
			"font-size",
			"separator",
			"bold",
			"italic",
			"underline",
			"strike",
			"separator",
			"text-color",
			"background-color",
			"separator",
			"subscript",
			"superscript",
			"separator",
			"align",
			"line-height",
			"outdent",
			"indent",
			"separator",
			"bulleted-list",
			"numbered-list",
			"quote",
			"separator",
			"link",
			"image",
			"line",
			"separator",
			"clear",
			"separator",
			"print",
			"separator",
			"fullscreen",
			"mode",
		];

		return "<div class='dhx-demo_richtext-view' style='height:100%;'></div>";
	}

	ready() {
		// @ts-ignore
		this.richtext = new Richtext(".dhx-demo_richtext-view", {
			menubar: true,
			toolbar: this.toolbarConfig,
			layoutMode: "document",
			value: this.initialContent,
		});

		return this.richtext;
	}
}
